import { defineMessages } from "react-intl";
const messages = defineMessages({
    prospectIntelligencePermissionLabel: {
        id: "app.users.createUser.prospectIntelligence.label.text",
        defaultMessage: "Select prospect intelligence permission",
    },
    prospectIntelligencePermissionOptionView: {
        id: "app.users.createUser.prospectIntelligence.option.view.text",
        defaultMessage: "View",
    },
    prospectIntelligencePermissionOptionDeny: {
        id: "app.users.createUser.prospectIntelligence.option.deny.text",
        defaultMessage: "No Access",
    },
});
export default messages;
